import { fetchResource } from 'helpers/fetch';
import { API_CONSTANTS } from 'constants/api';

export const COVERAGE_CODE_ACTIONS = {
  COVERAGE_CODES_RETRIEVED: 'COVERAGE_CODES_RETRIEVED',
  COVERAGE_CODES_LOADING_SET: 'COVERAGE_CODES_LOADING_SET',
};

export const setCoverageCodesLoading = (loading) => ({
  type: COVERAGE_CODE_ACTIONS.COVERAGE_CODES_LOADING_SET,
  data: { loading },
});

export const getCoverageCodeLookupData = async () => {
  const coverageCodes = await fetchResource(API_CONSTANTS.LOOKUP_COVERAGE_CODES);
  return coverageCodes;
};

export const getCoverageCodes = () => async (dispatch, getState) => {
  const { coverageCodes: { values: coverageCodesInState = [] } = {} } = getState();

  if (coverageCodesInState.length === 0) {
    dispatch(setCoverageCodesLoading(true));

    const coverageCodes = await getCoverageCodeLookupData();

    dispatch({
      type: COVERAGE_CODE_ACTIONS.COVERAGE_CODES_RETRIEVED,
      data: { coverageCodes: coverageCodes },
    });

    dispatch(setCoverageCodesLoading(false));
  }
};
